(() => {
    if (!customElements.get("swiper-component")) {
        customElements.define(
            "swiper-component",
            class SwiperComponent extends HTMLElement {
                /**
                 * 拓展属性 navigation pagination
                 */
                // navigation: {
                //     nextEl: '.button-next-{{section.id}}',
                //     prevEl: '.button-prev-{{section.id}}',
                //   },
                //   pagination: {
                //     el: '.home-swiper-pagination',
                //     clickable: true,
                //   },
                swiper_options = {
                    slidesPerView: 1,
                    spaceBetween: 40,
                    loop: false,
                    autoplay: false,
                    watchOverflow: true
                };
                constructor() {
                    super();
                    if (this.querySelector(".swiper-button-next")) {
                        this.swiper_options.navigation = {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        };
                    }
                    if (this.querySelector('.swiper-pagination')) {
                        this.swiper_options.pagination = {
                            el: '.swiper-pagination',
                            clickable: true,
                        }
                    }
                    this.initSwiper();
                }
                initSwiper() {
                    if (this.dataset.open == "true") {
                        Object.keys(this.dataset).forEach((key) => {
                            this.swiper_options[key] = JSON.parse(this.dataset[key]);
                        });
                        this.swiper = new Swiper(this.querySelector(".swiper-container"), {
                            ...this.swiper_options,
                            loop: Array.from(this.querySelectorAll('.swiper-slide') ?? []).length === 1 ? false : this.swiper_options.loop
                        });
                    }
                }
                slideTo(index) {
                    this.swiper.slideTo(index);
                }
            }
        );
    }

    customElements.define("section-range", class SectionRange extends HTMLElement {
        constructor() {
            super()
            this.init()
        }
        init() {
            this.tabs = this.querySelectorAll('.section-range-tab')
            this.updateSlider(this.tabs[0])
            const swiper = this.querySelector('swiper-component')
            this.tabs.forEach((item, index) => {
                item.addEventListener("click", () => {
                    swiper.slideTo(index)
                    this.updateSlider(item)
                })
            })

            swiper.on('slideChange', (e) => {
                this.updateSlider(this.tabs[e.activeIndex])
            })
        }
        updateSlider(item) {
            const { offsetLeft, offsetWidth } = item ?? activeTab;
            $(this.tabs).not(item).removeClass('active')
            item.classList.add('active')
            $(this.querySelector('.section-range-tabs')).css({
                ['--offsetLeft']: offsetLeft + 'px',
                ['--offsetWidth']: offsetWidth + 'px',
            });
        }
    })

    class VideoLazyLoad extends HTMLElement {
        constructor() {
            super()

        }
        connectedCallback() {
            this.videos = document.querySelectorAll('.video--lazyLoad')
            // 人机是否有交互
            this.interactState = false
            this.autoplayMap = []
            this.listenerInteract()
            this.listenerIntersectionObserver()
            this.listenerALick()
        }

        listenerIntersectionObserver() {
            const _this = this
            this.videoObserver = new IntersectionObserver(function (
                entries,
                observer
            ) {
                entries.forEach((entry) => {
                    let video = entry.target
                    if (entry.isIntersecting) {
                        if (!video.src) {
                            video.src = video.dataset.src
                        }
                        if (video.dataset.autoplay) {
                            // 有交互性则自动播放
                            _this.interactState ? video.play() : _this.autoplayMap.push(video)
                        }
                        // observer.unobserve(entry.target);
                    } else {
                        video.src && video.pause()
                    }
                });
            });

            this.videos.forEach(item => {
                this.videoObserver.observe(item);
            })
        }
        listenerInteract() {
            const startEvent = () => {
                this.interactState = true
                this.autoplayMap.forEach(video => video.play())
            }
            document.addEventListener('mousemove', startEvent, { once: true });
            document.addEventListener('touchstart', startEvent, { once: true });
        }

        listenerALick() {
            document.addEventListener('click', (event) => {
                if (event.target.tagName === 'A' && event.target.getAttribute('href') && this.videos.length) {
                    this.videos.forEach(video => video.pause())
                }
            });
        }
    }
    customElements.define('video-lazy-load', VideoLazyLoad)
})()